export default class Base {
  static get lastViewedVehicles() {
    throw new Error('Not implemented');
  }

  static get hasSearched() {
    throw new Error('Not implemented');
  }

  static get sentEnquiries() {
    throw new Error('Not implemented');
  }
}
